import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PublicLayout from "./Components/B2BStaticPages/PublicLayout";
import Login from "./Authentication/Login";
import AgentRegister from "./Authentication/Register";
import AboutCompany from "./Components/B2BStaticPages/AboutCompany";
import Agents from "./Components/B2BStaticPages/Agents";
import Careers from "./Components/B2BStaticPages/Careers";
import AboutContactUs from "./Components/B2BStaticPages/AboutContactUs";
import OurServices from "./Components/B2BStaticPages/OurServices";
import B2CLayout from "./Common/Layout/B2CLayout";
import FlightSearch from "./Components/Flight/SearchFlight";
import Flights from "./Components/Flight/Flights";
import FlightDetails from "./Components/Flight/FlightDetails";
import ReviewFlight from "./Components/Flight/ReviewFlight";
import FlightBookings from "./Components/Flight/FlightBookings";
import FlightBookingDetails from "./Components/Flight/FlightBookingDetails";
import HotelSearch from "./Components/Hotels/HotelSearch";
import HotelsList from "./Components/Hotels/HotelsList";
import HotelDetails from "./Components/Hotels/HotelDetails";
import HotelGuests from "./Components/Hotels/HotelGuests";
import HotelReview from "./Components/Hotels/HotelReview";
import HotelBookings from "./Components/Hotels/HotelBookings";
import HotelBookingDetails from "./Components/Hotels/HotelBookingDetails";
import HolidaysPage from "./Components/Holiday/HolidayScreen";
import HolidayPackageDetails from "./Components/Holiday/HolidayPackageDetails";
import HolidayResults from "./Components/Holiday/HolidayResults";
import TravelTypeResults from "./Components/Holiday/PackagesByTravelType";
import SearchSightSeeing from "./Components/SightSeeings/SearchSightSeeing";
import SightSeeingProducts from "./Components/SightSeeings/SightSeeingProducts";
import SightSeeingProduct from "./Components/SightSeeings/SightSeeingProduct";
import AboutUs from "./CompanyData/StaticPages/AboutUs";
import TermsAndConditions from "./CompanyData/StaticPages/Terms";
import Faq from "./CompanyData/StaticPages/Faq";
import PrivacyPolicy from "./CompanyData/StaticPages/PrivacyPolicy";
import RefundPolicy from "./CompanyData/StaticPages/RefundPolicy";
import ContactUs from "./CompanyData/StaticPages/ContactUs";
import GroupBookings from "./Components/Profile/GroupBooking";
import AccountLayout from "./Components/AccountLayout";
import EditProfileForm from "./Components/Profile/EditProfileForm";
import ChangePasswordForm from "./Components/Profile/ChangePassword";
import MyFlightBookings from "./Components/Bookings/MyFlightBookings";
import MyFlightBookingDetails from "./Components/Bookings/MyFlightBookingDetails";
import CompanyBranches from "./Components/Profile/Branch";
import CompanyUsers from "./Components/Profile/Users";
import MyHotelBookings from "./Components/Bookings/MyHotelBookings";
import MyHotelBookingDetails from "./Components/Bookings/MyHotelBookingDetails";
import FlightInvoice from "./Components/Flight/FlightInvoice";
import FlightVoucher from "./Components/Flight/FlightVoucher";
import HotelVoucher from "./Components/Hotels/HotelVoucher";
import HotelInvoice from "./Components/Hotels/HotelInvoice";
import FlightReport from "./Components/Report/FLightReport";
import HotelReport from "./Components/Report/HotelReport";
import DestinationPackages from "./Components/Holiday/PackageByDestination";
import ForgotPassword from "./Authentication/ForgotPassword";
import ResetPassword from "./Authentication/ResetPassword";
function App() {
  return (
    <>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="/agentregister" element={<AgentRegister />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/about-company" element={<AboutCompany />} />
          <Route path="/about-agents" element={<Agents />} />
          <Route path="/about-careers" element={<Careers />} />
          <Route path="/about-contact" element={<AboutContactUs />} />
          <Route path="/our-services" element={<OurServices />} />
        </Route>
        <Route element={<B2CLayout />}>
          <Route path="/flight/search" element={<FlightSearch />} />
          <Route path="/flight/:adults?/:kids?/:infants?/:isDomestic?" element={<Flights />} />
          <Route path="/flightdetails/:adults?/:kids?/:infants?/:isDomestic?" element={<FlightDetails />} />
          <Route path="/flight/review/:adults?/:kids?/:infants?/:isDomestic?" element={<ReviewFlight />} />
          <Route path="/flight/bookings" element={<FlightBookings />} />
          <Route path="/flight/booking/:flightBookingId" element={<FlightBookingDetails />} />
          {/* <Route path="/flight/voucher/:flightBookingId" element={<FlightVoucher />} /> */}
          {/* <Route path="/flight/invoice/:flightBookingId" element={<FlightInvoice />} /> */}

          <Route path="/hotel/search" element={<HotelSearch />} />
          <Route path="/hotels" element={<HotelsList />} />
          <Route path="/hotel/details/:hotelId?" element={<HotelDetails />} />
          <Route path="/hotel/guests" element={<HotelGuests />} />
          <Route path="/hotel/review" element={<HotelReview />} />
          <Route path="/hotel/bookings" element={<HotelBookings />} />
          <Route path="/hotel/booking/:hotelBookingId" element={<HotelBookingDetails />} />
          {/* <Route path="/hotel/voucher/:hotelBookingId" element={<HotelVoucher />} />
        <Route path="/hotel/invoice/:hotelBookingId" element={<HotelInvoice />} />
         */}
          <Route path="/holidays" element={<HolidaysPage />} />
          <Route path="/holiday-details/:packageId" element={<HolidayPackageDetails />} />
          <Route path="/holidays/search" element={<HolidayResults />} />
          <Route path="/packages/type/:travelTypeName" element={<TravelTypeResults />} />

          <Route path="/search/sightseeing" element={<SearchSightSeeing />} />
          <Route path="/sightseeing/products/:destinationCode/:destination/:adults?/:kids?/:travelDate" element={<SightSeeingProducts />} />
          <Route path="/sightseeing/product/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate" element={<SightSeeingProduct />} />
          <Route path="/destination/:destinationId" element={<DestinationPackages />} />

          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="bookingrequest" element={<GroupBookings />} />
          <Route element={<AccountLayout />}>
            <Route path="/my-profile" element={<EditProfileForm />} />
            <Route path="/change-password" element={<ChangePasswordForm />} />
            <Route path="/my-flightbookings" element={<MyFlightBookings />} />
            <Route path="/my-flight/booking/:flightBookingId" element={<MyFlightBookingDetails />} />
            <Route path="/manage-branches" element={<CompanyBranches />} />
            <Route path="/manage-users" element={<CompanyUsers />} />
            <Route path="/my-hotelbookings" element={<MyHotelBookings />} />
            <Route path="/my-hotel/booking/:hotelBookingId" element={<MyHotelBookingDetails />} />
            <Route path="/flight/invoice/:flightBookingId" element={<FlightInvoice />} />
            <Route path="/flight/voucher/:flightBookingId" element={<FlightVoucher />} />
            <Route path="/hotel/voucher/:hotelBookingId" element={<HotelVoucher />} />
            <Route path="/hotel/invoice/:hotelBookingId" element={<HotelInvoice />} />
            <Route path="/flightreport" element={<FlightReport />} />
            <Route path="/hotelreport" element={<HotelReport />} />

          </Route>
        </Route>
        {/*B2C END*/}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;